import Vue from 'vue'
import VueTour from '@/components/Tour/index'
// require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)
